import getMailboxFullMessageViewState from './getMailboxFullMessageViewState';
import { InfoBarMessageViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import MailTipsCacheEntry from '../store/schema/MailTipsCacheEntry';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import getDeliveryRestrictedMessageViewState from './getDeliveryRestrictedMessageViewState';
import getExternalMemberCountMessageViewState from './getExternalMemberCountMessageViewState';
import getModeratedMailboxesMessageViewState from './getModeratedMailboxesMessageViewState';
import getAutomaticRepliesMessageViewState from './getAutomaticRepliesMessageViewState';
import getAccessibilityMessageViewState from './getAccessibilityMessageViewState';
import getLargeAudienceMessageViewState from './getLargeAudienceMessageViewState';
import { NestedMruCache } from 'owa-nested-mru-cache';
import getGuestsDisabledMessageViewState from './getGuestsDisabledMessageViewState';
import getCustomMessageViewState from './getCustomMessageViewState';
import createMailTipsViewState from '../utils/createMailTipsViewState';
import MailTipsViewState from '../store/schema/MailTipsViewState';

/**
 * Creates infoBarViewStates for recipient depending on the MailTips data in cache
 */
const getMailTipMessageViewStates = (
    recipients: EmailAddressWrapper[],
    mailTips: NestedMruCache<MailTipsCacheEntry>,
    fromEmailAddress: string,
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void,
    onAccessibilityCheckerClick: () => void
): InfoBarMessageViewState[] => {
    const finalMailTipsInfo: MailTipsViewState = createMailTipsViewState(
        recipients,
        mailTips,
        fromEmailAddress
    );

    let mailTipsViewStates;
    if (onRemoveRecipientsClick) {
        // Call all mailtips handlers
        mailTipsViewStates = [
            getDeliveryRestrictedMessageViewState(
                finalMailTipsInfo.DeliveryRestricted,
                onRemoveRecipientsClick
            ),
            getExternalMemberCountMessageViewState(
                finalMailTipsInfo.ExternalMemberCount,
                onRemoveRecipientsClick
            ),
            getModeratedMailboxesMessageViewState(
                finalMailTipsInfo.IsModerated,
                onRemoveRecipientsClick
            ),
            getMailboxFullMessageViewState(finalMailTipsInfo.MailboxFull, onRemoveRecipientsClick),
            getAutomaticRepliesMessageViewState(
                finalMailTipsInfo.OutOfOffice,
                onRemoveRecipientsClick
            ),
            getAccessibilityMessageViewState(
                finalMailTipsInfo.PreferAccessibleContent,
                onAccessibilityCheckerClick
            ),
            getLargeAudienceMessageViewState(
                finalMailTipsInfo.TotalMemberCount,
                onRemoveRecipientsClick
            ),
            getGuestsDisabledMessageViewState(
                finalMailTipsInfo.GuestsDisabledGroupsWithGuests,
                onRemoveRecipientsClick
            ),
            getCustomMessageViewState(finalMailTipsInfo.CustomMailTip),
        ];
    } else {
        // Exclude calling the mailtips handlers which require the onRemoveReceipientsClick
        mailTipsViewStates = [
            getAccessibilityMessageViewState(
                finalMailTipsInfo.PreferAccessibleContent,
                onAccessibilityCheckerClick
            ),
            getCustomMessageViewState(finalMailTipsInfo.CustomMailTip),
        ];
    }

    return mailTipsViewStates.filter(message => !!message);
};

export default getMailTipMessageViewStates;
